/** List of supported language locale codes. */
export const supportedLocales = [
  'ar', // العربية (Arabic)
  'cs', // Czech
  'da', // Danish
  'de', // German
  'en', // English
  'es', // Spanish
  'fr', // French
  'hi', // Indian
  'hu', // Magyar
  'id', // Indonesian
  'it', // Italian
  'ja', // Japanese
  'ko', // Korean
  'ms', // Malay
  'nl', // Netherlands
  'no', // Norwegian
  'fil', // Filipino
  'pl', // Polish
  'pt', // Portuguese
  'ro', // Romanian
  'ru', // Russian
  'sv', // Swedish
  'th', // Thai
  'tr', // Turkish
  'ur', // Urdu
  'vi', // Vietnamese
  'zh', // Mandarin
] as const
